import Header from '../components/Header';
import Footer from '../components/Footer';
import { useTranslation } from 'react-i18next';
import usePageTitle from '../hooks/usePageTitle';
import useCanonicalTag from '../hooks/useCanonicalTag';
import useMetaTags from '../hooks/useMetaTags';
import '../styles/fonts.css';

function Privacy() {
  const { t } = useTranslation();
  usePageTitle('Política de Privacidade');
  useCanonicalTag();
  useMetaTags({ title: 'Política de Privacidade | Celeritas', url: 'https://celeritas.live/privacidade' });
  const s = { fontSize: '14px', lineHeight: '1.7', color: '#8b949e' };
  const li = { fontSize: '14px', lineHeight: '1.9', color: '#8b949e', paddingLeft: '20px', marginTop: '8px' };
  const h2 = { fontSize: '17px', fontWeight: 600, color: '#e6edf3', marginBottom: '10px' };
  const strong = { color: '#c9d1d9' };

  return (
    <div style={{ minHeight: '100vh', background: '#1b1f23', display: 'flex', flexDirection: 'column' }}>
      <Header />
      <main style={{ flex: 1, maxWidth: '800px', margin: '0 auto', padding: '48px 24px', color: '#c9d1d9' }}>
        <h1 style={{ fontSize: '28px', fontWeight: 700, marginBottom: '8px', color: '#fff' }}>{t('privacy.title')}</h1>
        <p style={{ fontSize: '13px', color: '#8b949e', marginBottom: '40px' }}>{t('privacy.lastUpdated')}</p>

        <section style={{ marginBottom: '32px' }}>
          <h2 style={h2}>{t('privacy.s1_title')}</h2>
          <p style={s}>{t('privacy.s1_text')}</p>
          <ul style={li}>
            <li><strong style={strong}>{t('privacy.s1_li1_label')}</strong> {t('privacy.s1_li1_text')}</li>
            <li><strong style={strong}>{t('privacy.s1_li2_label')}</strong> {t('privacy.s1_li2_text')}</li>
            <li><strong style={strong}>{t('privacy.s1_li3_label')}</strong> {t('privacy.s1_li3_text')}</li>
          </ul>
        </section>

        <section style={{ marginBottom: '32px' }}>
          <h2 style={h2}>{t('privacy.s2_title')}</h2>
          <p style={s}>{t('privacy.s2_text')}</p>
          <ul style={li}>
            <li>{t('privacy.s2_li1')}</li>
            <li>{t('privacy.s2_li2')}</li>
            <li>{t('privacy.s2_li3')}</li>
          </ul>
          <p style={{ ...s, marginTop: '10px' }}>{t('privacy.s2_note')}</p>
        </section>

        <section style={{ marginBottom: '32px' }}>
          <h2 style={h2}>{t('privacy.s3_title')}</h2>
          <p style={s}>{t('privacy.s3_text')}</p>
        </section>

        <section style={{ marginBottom: '32px' }}>
          <h2 style={h2}>{t('privacy.s4_title')}</h2>
          <p style={s}>{t('privacy.s4_text')}</p>
        </section>

        <section style={{ marginBottom: '32px' }}>
          <h2 style={h2}>{t('privacy.s5_title')}</h2>
          <p style={s}>{t('privacy.s5_text')}</p>
        </section>

        <section style={{ marginBottom: '32px' }}>
          <h2 style={h2}>{t('privacy.s6_title')}</h2>
          <p style={s}>{t('privacy.s6_text')}</p>
        </section>

        <section style={{ marginBottom: '32px' }}>
          <h2 style={h2}>{t('privacy.s7_title')}</h2>
          <p style={s}>{t('privacy.s7_text')}</p>
        </section>

        <section>
          <h2 style={h2}>{t('privacy.s8_title')}</h2>
          <p style={s}>
            {t('privacy.s8_text')}{' '}
            <a href="https://discord.gg/mR45gCfark" target="_blank" rel="noopener noreferrer"
               style={{ color: '#5865F2', textDecoration: 'none' }}>{t('privacy.s8_discord')}</a>.
          </p>
        </section>
      </main>
      <Footer />
    </div>
  );
}

export default Privacy;
